<template>
    <div class="automation_view">
        <iframe id="iframeDom" ref="iframeDom" :src="iframeSrc" frameborder="0"></iframe>
        <div class="mark" v-if="markFlag"></div>
    </div>
</template>

<script>
// 'http://localhost:8086/#/'
export default {
    data () {
        return {
            iframeSrc: 'https://wisdom.askbot.cn/automated-processes/index.html',
            // iframeSrc:'http://localhost:8083/#/',
            markFlag: false
        }
    },
    created() {
        // 进入自动化流程前，若通知抽屉已打开则先关闭
        try { if (typeof window !== 'undefined') { window.dispatchEvent(new Event('notification:close-center')) } } catch (e) { /* ignore */ }
        // 从 sessionStorage 获取用户信息
        const mainId = sessionStorage.getItem('_mainId');
        const uid = sessionStorage.getItem('_uid');
        const corpId = sessionStorage.getItem('_corpId');
        
        // 构建 URL 参数
        const params = new URLSearchParams();
        if (mainId) params.append('mainId', mainId);
        if (uid) params.append('uid', uid);
        if (corpId) params.append('corpId', corpId);
        // 强制子应用进入列表页（旧版本子应用可忽略该参数，不影响兼容）
        params.append('forceList', '1');
        
        const queryString = params.toString();
        const separator = queryString ? '?' : '';
        
        // 本地调试模式 - 可以通过修改这个条件来切换
        const isLocalDebug = false; // 设置为 false 恢复原来的环境判断
        
        if (isLocalDebug) {
            this.iframeSrc = `http://localhost:8082/#/${separator}${queryString}`;
        } else {
            const baseUrl = process.env.VUE_APP_NODE_ENV == 'production' 
                ? 'https://wisdom.askbot.cn/automated-processes/index.html' 
                : 'https://wisdom.test.askbot.cn/automated-processes/index.html';
            this.iframeSrc = `${baseUrl}${separator}${queryString}`;
        }
    },
    mounted () {
        // 进入自动化菜单时，清除残留的详情缓存，避免子页读取到历史自动化数据
        try { localStorage.removeItem('automated') } catch (e) { /* ignore cleanup error */ }
        window.addEventListener("message", (e) => {
            if (e.data.type == 'toDetail') {
                this.$emit('automationDetail', true)
            } else if (e.data.type == 'toList') {
                this.$emit('automationDetail', false)
            } else if (e.data.type == 'openMark') {
                this.markFlag = e.data.data
            }
        })
        setTimeout(() => {
            // 仅在明确允许的情况下，才通知子页回到详情（避免从菜单进入时误跳详情）
            const allow = sessionStorage.getItem('automation_allow_parent_detail') === 'true'
            if (allow) {
                const automatedRaw = localStorage.getItem("automated")
                if (automatedRaw) {
                    try {
                        const automated = JSON.parse(automatedRaw)
                        if (automated && automated.id) {
                            let iframeDom = document.getElementById("iframeDom")
                            let _window = iframeDom.contentWindow
                            _window.postMessage({ type: 'backDetail', data: automated.id }, '*')
                        }
                    } catch (e) { /* ignore parse error */ }
                }
                // 一次性许可，用后即焚
                sessionStorage.removeItem('automation_allow_parent_detail')
            }
        }, 100)
    },
    methods: {
        addAutomation () {
            let iframeDom = document.getElementById("iframeDom")
            let _window = iframeDom.contentWindow
            _window.postMessage({ type: 'addAutomation', data: '' }, '*')
            // setTimeout(() => {
            //     // 延迟200ms 的动画帧
            //     this.markFlag = true
            // }, 100)
        },
        adjustPriority(automationSort) {
            let iframeDom = document.getElementById("iframeDom")
            let _window = iframeDom.contentWindow
            _window.postMessage({ type: 'adjustPriority', data: automationSort }, '*')
        }
    }
}
</script>

<style lang="less" scoped>
.automation_view {
    width: 100%;
    height: 100%;

    iframe {
        width: 100%;
        height: 100%;
        border: none;
        position: relative;
        z-index: 999;
    }

    .mark {
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100vw;
        height: 100vh;
        opacity: .5;
        background: #000;
        z-index: 99;
    }
}
</style>
